(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

<!-- eSig Section BEGIN --> 
  
  const cartItemAddUnsubscribeHandler = subscribe(PUB_SUB_EVENTS.cartItemQuantityUpdate, (data) => 
  {
     console.log("Item updated in cart cartItemQuantityUpdate : ", data); 

    let tbIs_eSigRequired = 0;

    tbIs_eSigRequired = eSigRadioFrequencyEnumItems( data.cart.items );

    eSigRadioFrequencyEnforcer( tbIs_eSigRequired );
    
  });

  const cartItemRemoveUnsubscribeHandler = subscribe(PUB_SUB_EVENTS.cartItemRemove, (data) => 
  {
	 console.log("Item removed from cart cartItemRemove : ", data); 

    let tbIs_eSigRequired = 0;

    tbIs_eSigRequired = eSigRadioFrequencyEnumItems( data.cart.items );

    eSigRadioFrequencyEnforcer( tbIs_eSigRequired );
    
  });

<!-- eSig Section END -->



  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
